import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild
} from '@angular/core';
import { NbDialogRef, NbDialogService } from '@nebular/theme';
import { ViewCell } from 'ng2-smart-table';
import Viewer from 'viewerjs';

@Component({
  selector: 'app-image-modal',
  templateUrl: './image-modal-selfie.component.html',
  styleUrls: ['./image-modal-selfie.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImageModalSelfieComponent implements OnInit, ViewCell, OnDestroy {
  @ViewChild('photoDialog') photoDialog!: TemplateRef<any>;
  @ViewChild('image') image!: ElementRef;
  @ViewChild('imageList') imageList!: ElementRef;
  imageIsResolved = false;

  private _dialogRef?: NbDialogRef<any>;

  @Input() set value(data: any) {
    this.data = data;
  }

  @Input() rowData: any;
  data: any;
  viewImage = false;
  viewer!: Viewer;
  viewerOpen = false;

  constructor(private dialogService: NbDialogService) {}

  showImages(): void {
    // this.viewImage = true;
    setTimeout(() => {
      this.viewer = new Viewer(this.imageList.nativeElement, {
        inline: false,
        zoomRatio: 0.3,
        zIndex: 999999999,
        toolbar: {
          zoomIn: true,
          zoomOut: true,
          oneToOne: true,
          reset: false,
          prev: false,
          play: false,
          next: false,
          rotateLeft: true,
          rotateRight: true,
          flipHorizontal: true,
          flipVertical: true
        }
      });
    });
  }

  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.viewer?.destroy();
  }

  openImageModal() {
      this._dialogRef = this.dialogService.open(this.photoDialog, {
        context: {
          selfie: this.data.img,
          identity: this.data.row.national_id_path
        },
        closeOnEsc: false
      });
    // this.viewer = new Viewer(this.image.nativeElement, {
    //   inline: false,
    //   zoomRatio: 0.3,
    //   toolbar: {
    //     zoomIn: true,
    //     zoomOut: true,
    //     oneToOne: true,
    //     reset: false,
    //     prev: false,
    //     play: false,
    //     next: false,
    //     rotateLeft: true,
    //     rotateRight: true,
    //     flipHorizontal: true,
    //     flipVertical: true
    //   }
    // });
    // this.image.nativeElement.click();
  }

  imageResolved() {
    this.imageIsResolved = true;
    this.openImageModal();
  }
}
